export const headerCells = [
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID"
  },
  {
    id: "licenseeName",
    numeric: false,
    disablePadding: true,
    label: "Licensee Name"
  },
  {
    id: "songTitles",
    numeric: false,
    disablePadding: true,
    label: "Song Titles"
  },

  {
    id: "dateIssued",
    numeric: false,
    disablePadding: true,
    label: "Date Issued"
  },

  {
    id: "dateExecuted",
    numeric: false,
    disablePadding: true,
    label: "Date Executed"
  },
  {
    id: "paymentDueDate",
    numeric: false,
    disablePadding: true,
    label: "Payment Due Date"
  },
  {
    id: "datePaid",
    numeric: false,
    disablePadding: true,
    label: "Date Paid"
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status"
  }
];

export default headerCells;
